var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServiceModulLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 19.5,
    stroke: "white",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5063_753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3826 11.1152L13.1288 11.657L15.7948 13.2821C15.7948 14.6364 15.287 15.7199 14.1445 16.397L11.4783 14.7719L11.3514 15.0427C11.9862 17.0742 13.2557 18.4285 15.7948 18.4285C16.4296 18.4285 18.334 20.46 19.3496 21.5433L21.3809 19.3765C20.3652 18.2931 18.08 15.8553 18.08 15.1782C18.08 12.7404 17.4452 11.1152 13.3826 11.1152ZM29.2521 11.7924L26.713 13.6884L26.4591 14.7719L19.0957 22.6267L18.08 21.9496L17.5722 22.4913C17.5722 24.1165 15.7948 24.9291 15.0331 24.9291L10.8436 29.3983C10.8436 30.7526 12.24 32.2422 13.5097 32.2422L17.6991 27.7731C17.6991 26.9605 18.4609 25.0645 19.9843 25.0645L20.4922 24.5228L19.8574 23.4393L27.2208 15.5844L28.2364 15.3136L30.0138 12.605L29.2521 11.7924ZM22.9043 21.0017L20.8731 23.1685C22.3965 24.7936 24.4278 26.9605 24.4278 27.6377C24.4278 30.0754 25.0626 31.7006 29.1252 31.7006L29.3791 31.1589L26.713 29.5337C26.713 28.1794 27.2208 27.096 28.3634 26.4188L31.0295 28.044L31.1564 27.7731C30.5217 25.7417 29.2521 24.3873 26.713 24.3873C26.0782 24.3873 24.4278 22.6267 22.9043 21.0017Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5063_753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.3226,
    height: 21.6774,
    fill: "white",
    transform: "translate(10.8387 10.8398)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceModulLogo);
export default __webpack_public_path__ + "static/media/service_modul_logo.d3c583a9566f8d1a0001cccf6db8dce8.svg";
export { ForwardRef as ReactComponent };